<template>
  <aside class="admin-aside admin-aside--series" v-if="user">
    <button class="admin-aside__toggler" v-show="!panelMode" @click.prevent="toggleView()">
      <svg width="50" height="50" class="admin-aside__toggler-svg">
        <use xlink:href="#svg-gear" />
      </svg>
    </button>
    <div class="admin-aside__wrapper" v-show="panelMode">
      <button class="admin-aside__close" @click.prevent="toggleView()">
        <svg width="15" height="15" class="admin-aside__close-svg">
          <use xlink:href="#svg-close" />
        </svg>
      </button>
      <ul class="admin-aside__navigation">
        <li class="admin-aside__item" v-for="control in controls" v-if="checkAccess(control)">
          <a :href="control.url" class="square-button square-button-blue">{{ control.label }}</a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
  import { mapGetters } from 'vuex'
  import '../../../sass/elements/_controls.scss';

  export default {
    name: 'Controls',
    props: {
    },
    data: function () {
      return {
        panelMode: false
      }
    },
    created: function () {

    },
    computed: {
      ...mapGetters({
        course: 'courses/course',
        controls: 'pages/controls',
        user: 'auth/user',
        users: 'users/users',
      }),
    },
    filters: {
    },
    methods: {
      checkAccess (control) {
        let accessGranted = false;
        for (const role of control.roles) {
          if (role === 'teacher') {
            if (this.course && this.course.teacherId === this.user.id) {
              accessGranted = true;
              break;
            }
          } else {
            if (this.user.roles.indexOf(role) !== -1) {
              accessGranted = true;
              break;
            }
          }
        }
        return accessGranted;
      },
      toggleView () {
        this.panelMode = !this.panelMode
      },
    }
  }
</script>

